// extracted by mini-css-extract-plugin
export default {"container":"test_container__s0STL","block":"test_block__s31W8"};